import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import styles from './tag.module.scss';

export type TagVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'quinary';

export interface TagProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** The class name to apply */
  className?: string;
  /** An event that is triggered on click */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  /** The size of the tag to show */
  size?: 'large' | 'small';
  /** The text to display */
  text: string;
  /** The variant style to use for the tag */
  variant?: TagVariant;
}

const variants: Record<TagVariant, string> = {
  primary: styles.isPrimary,
  secondary: styles.isSecondary,
  tertiary: styles.isTertiary,
  quaternary: styles.isQuaternary,
  quinary: styles.isQuinary,
};

const Tag = ({
  className,
  size = 'small',
  text,
  variant = 'primary',
  onClick,
  ...rest
}: TagProps) => {
  const renderContent = (
    <Typography
      tag="span"
      tagStyle={size === 'large' ? 'labelMedium' : 'labelSmall'}
    >
      {text}
    </Typography>
  );

  return onClick ? (
    <button
      {...rest}
      className={classNames(styles.component, className, variants[variant], {
        [styles.isLarge]: size === 'large',
      })}
      onClick={onClick}
    >
      {renderContent}
    </button>
  ) : (
    <div className={classNames(styles.component, className, variants[variant])}>
      {renderContent}
    </div>
  );
};

Tag.displayName = 'Tag';

export default Tag;
